import { render, staticRenderFns } from "./MenuFab.vue?vue&type=template&id=7a8de6f7&scoped=true&"
import script from "./MenuFab.vue?vue&type=script&lang=js&"
export * from "./MenuFab.vue?vue&type=script&lang=js&"
import style0 from "./MenuFab.vue?vue&type=style&index=0&id=7a8de6f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8de6f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
installComponents(component, {VBtn,VChip,VContainer,VIcon,VSpeedDial})
